import {useCallback, useEffect, useState} from "react";
import {addYears} from "date-fns";
import {toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {getInspectionReportCodeList} from "../../../api/inspectionReportCode/InspectionReportCodeService";
import {getDailyCheckList} from "../../../api/dailyCheck/DailyCheckService";

const DEFAULT_SEARCH = () => ({
    startDate: toKSTISOString(addYears(new Date(), -1)),
    endDate: toKSTISOStringEnd(new Date()),
});

const DEFAULT_PAGEABLE = {
    page: 0,
    size: 500,
    sort: "id",
    desc: true,
};

export function useReportCodeList(categoryId) {
    const [listData, setListData] = useState([]);
    const [loading, setLoading] = useState(false);

    const loadList = useCallback(async () => {
        if (!categoryId) {
            setListData([]);
            return [];
        }

        setLoading(true);
        try {
            const search = DEFAULT_SEARCH();
            const pageable = DEFAULT_PAGEABLE;

            if (categoryId === "inspectionReport") {
                const response = await getInspectionReportCodeList(search, pageable);
                const data = response?.data?.content ?? [];
                setListData(data);
                return data;
            }

            if (categoryId === "dailyCheck") {
                const response = await getDailyCheckList(search, pageable);
                const data = response?.data?.content ?? [];
                setListData(data);
                return data;
            }

            setListData([]);
            return [];
        } finally {
            setLoading(false);
        }
    }, [categoryId]);

    useEffect(() => {
        loadList();
    }, [loadList]);

    return {listData, loading, reload: loadList};
}
